<script>
   /*************************************************************
   * AcceptancePlotLimits                                       *
   * --------------------                                       *
   * shows plot with acceptance limits for extreme and outliers *
   **************************************************************/

   import { Lines } from 'svelte-plots-basic/2d';
   import { Vector } from 'mdatools/arrays';

   export let resobj;                    // JSON with SIMCA results
   export let transType = 'no';          // transformation type ('log' or 'none')
   export let xMax = 0;                  // max value for x-coordinates of limits
   export let yMax = 0;                  // max value for y-coordinates of limits
   export let scope = 'objects';         // plot scope
   export let ncomp = 1;                 // number of components selected by user
   export let isAlt = false;

   /*****************************************/
   /* Component code                        */
   /*****************************************/

   const NPOINTS = 100;             // number of points in limit lines
   const LINE_COLOR = '#909090';    // color of the lines


   // function computes x and y coordinates for given critical value
   function get_limit_coordinates(crit, Nx, Ny, transType) {
      // show limit for orthogonal and score distance
      const b0 = crit/Ny;
      const b1 = -Nx / Ny;
      const xMax = -b0 / b1;
      const x = Vector.seq(0, xMax * 1, xMax  / NPOINTS);
      const y = x.apply(v => v * b1 + b0);
      return {
         x:  transType === 'log' ? x.apply(v => Math.log(1 + v)) : x,
         y:  transType === 'log' ? y.apply(v => Math.log(1 + v)) : y
      }
   }

   let els = null, ols = null;
   $: if (resobj && ncomp) {
      let Nx, Ny, oCrit, eCrit;
      const res = resobj.v[ncomp - 1];
      if (scope === 'objects') {
         Nx = res.Nh;
         Ny = res.Nq;
         oCrit = res.oCrit;
         eCrit = res.eCrit;
      } else {
         Nx = res.Ng;
         Ny = res.Nr;
         oCrit = res.voCrit;
         eCrit = res.veCrit;
      }

      els = get_limit_coordinates(eCrit, Nx, Ny, transType);

      // no need to show outliers border for alternative class predictions
      if (!isAlt) {
         ols = get_limit_coordinates(oCrit, Nx, Ny, transType);
         xMax = ols.x.v[NPOINTS - 1];
         yMax = ols.y.v[0];
      } else {
         ols = null;
         xMax = els.x.v[NPOINTS - 1];
         yMax = els.y.v[0];
      }
   } else {
      els = null;
      ols = null;
      xMax = 1;
      yMax = 1;
   }
</script>

{#if els }
<Lines xValues={els.x} yValues={els.y} lineColor={LINE_COLOR} lineType={2} />
{/if}

{#if ols && !isAlt }
<Lines xValues={ols.x} yValues={ols.y} lineColor={LINE_COLOR} lineType={3} />
{/if}
